import { gql } from '@apollo/client'

export const ActivityFragment = gql`
  fragment ActivityFragment on Activity {
    id
    createdDate
    status
    type
    data
    user {
      id
      email
      firstName
      lastName
    }
  }
`
